import { useCreation } from 'ahooks';
import classnames from 'classnames';
import React, { isValidElement } from 'react';
import { isNone } from '../_util/defineType';
import Elevation from '../elevation';
import Steps from '../steps';
import Typography from '../typography';
import BasicLayout, { BasicLayoutHeader } from './basic-layout';
import Footer from './footer';
import { isContentConfig } from './interface';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const FixbarLayoutBanner = props => {
  const {
    icon,
    title,
    subtitle,
    className,
    style,
    prefixClass = 'zen-design-layout-fixbar'
  } = props;
  const baseClassName = "".concat(prefixClass, "-banner");
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/React.isValidElement(icon) && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--icon"),
      children: icon
    }), /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--content"),
      children: [/*#__PURE__*/_jsx(Typography.Title, {
        size: "20-24",
        children: title
      }), /*#__PURE__*/React.isValidElement(subtitle) && /*#__PURE__*/_jsx(Typography.Text, {
        size: "16-20",
        children: subtitle
      })]
    })]
  });
};
export const FixbarLayoutBody = props => {
  const {
    banner,
    topBar,
    rightCol,
    children,
    className,
    style,
    prefixClass = 'zen-design-layout-fixbar'
  } = props;
  const baseClassName = "".concat(prefixClass, "-body");
  const top = useCreation(() => {
    const bannerExists = !isNone(banner);
    const topBarExists = !isNone(topBar);
    if (bannerExists || topBarExists) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [bannerExists && /*#__PURE__*/_jsx("div", {
          className: "left-col--banner",
          children: banner
        }), topBarExists && /*#__PURE__*/_jsx(Elevation, {
          type: 3,
          className: "left-col--top",
          style: {
            borderTopLeftRadius: bannerExists ? 0 : 'inherit',
            borderTopRightRadius: bannerExists ? 0 : 'inherit'
          },
          children: topBar
        })]
      });
    }
    return null;
  }, [banner, topBar]);
  const right = useCreation(() => {
    if (rightCol) {
      return /*#__PURE__*/_jsx("div", {
        className: "right-col",
        children: rightCol
      });
    }
    return null;
  }, [rightCol]);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    children: [/*#__PURE__*/_jsxs(Elevation, {
      type: 3,
      className: "left-col",
      children: [top, /*#__PURE__*/_jsx("div", {
        className: "left-col--content",
        children: children
      })]
    }), rightCol]
  });
};
export const FixbarLayoutStepBody = props => {
  const {
    banner,
    stepConfig,
    className,
    style
  } = props;
  const {
    current,
    steps,
    hidden
  } = stepConfig;
  const elements = useCreation(() => {
    if (steps.length === 0) {
      return undefined;
    }
    const top = hidden ? null : /*#__PURE__*/_jsx(Steps, {
      currentStep: current,
      steps: steps.map(_ref => {
        let {
          name
        } = _ref;
        return {
          name
        };
      }),
      scrollIntoView: true
    });
    const left = [];
    const right = [];
    steps.slice(0, current + 1).forEach((_ref2, idx) => {
      let {
        name,
        content
      } = _ref2;
      if (isContentConfig(content)) {
        left.push( /*#__PURE__*/_jsx("div", {
          style: {
            display: idx === current ? 'block' : 'none'
          },
          children: content.left
        }, name));
        right.push( /*#__PURE__*/isValidElement(content.right) ? /*#__PURE__*/_jsx("div", {
          className: "right-col",
          style: {
            display: idx === current ? 'block' : 'none'
          },
          children: content.right
        }, name) : null);
      } else {
        left.push( /*#__PURE__*/_jsx("div", {
          style: {
            display: idx === current ? 'block' : 'none'
          },
          children: content
        }, name));
      }
    });
    return {
      top,
      left,
      right
    };
  }, [current, steps, hidden]);
  return /*#__PURE__*/_jsx(FixbarLayoutBody, {
    banner: banner,
    topBar: elements === null || elements === void 0 ? void 0 : elements.top,
    rightCol: elements === null || elements === void 0 ? void 0 : elements.right,
    className: className,
    style: style,
    children: elements === null || elements === void 0 ? void 0 : elements.left
  });
};
const FixbarLayout = props => {
  var _stepConfig$steps$ste;
  let {
    title,
    howToUrl,
    whatIsUrl,
    subtitle,
    extra,
    stepConfig,
    children,
    banner,
    footer,
    fixbar,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-layout-fixbar");
  const currentStepContent = stepConfig === null || stepConfig === void 0 || (_stepConfig$steps$ste = stepConfig.steps[stepConfig.current]) === null || _stepConfig$steps$ste === void 0 ? void 0 : _stepConfig$steps$ste.content;
  const hideFixbarAndFooter = isContentConfig(currentStepContent) && /*#__PURE__*/isValidElement(currentStepContent.right);
  return /*#__PURE__*/_jsxs(BasicLayout, {
    className: classnames(baseClassName, className, {
      ['no-bar']: !fixbar || hideFixbarAndFooter
    }),
    style: style,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--main"),
      children: [/*#__PURE__*/_jsx(BasicLayoutHeader, {
        title: title,
        howToUrl: howToUrl,
        whatIsUrl: whatIsUrl,
        subtitle: subtitle,
        extra: extra
        // onBack={onBack}
      }), children, !!stepConfig && /*#__PURE__*/_jsx(FixbarLayoutStepBody, {
        banner: banner,
        stepConfig: stepConfig,
        prefixClass: baseClassName
      })]
    }), !!fixbar && /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--fixbar"),
      children: [/*#__PURE__*/_jsx(Elevation, {
        type: 5,
        borderRadius: false,
        children: fixbar
      }), footer === true ? /*#__PURE__*/_jsx(Footer, {
        prefixClass: prefixClass
      }) : footer]
    })]
  });
};
export default FixbarLayout;